import { GET_VARIANT_LIST, GetVariantListResponseDto } from '../../configs/APISchemas/GetVariantList';
import { GraphQLRequest } from '../../helpers/GraphQLRequest';
import { useCallback, useMemo, useState } from 'react';
import { Metrics, SEND_EXPERIMENT, SendExperimentResponseDto } from '../../configs/APISchemas/SendExperiment';
import { loadEntityIdFromStorage } from './AbTestProvider';
import { useSelector } from 'react-redux';
import { Store } from '../../types';
import { VariantType } from '../../redux/reducer/Variants';
import { useLocation } from 'react-router-dom';

export const useExperiment = () => {
  const [isLoading, setIsLoading] = useState(false);

  const sendExperiment = useCallback(async (metricsArray: Metrics[]) => {
    const mutation = SEND_EXPERIMENT({ entityId: loadEntityIdFromStorage(), metricsArray })
    try {
      setIsLoading(true);

      return await GraphQLRequest<SendExperimentResponseDto>(mutation)
    } finally {
      setIsLoading(false);
    }
  }, [])

  return { isLoading, sendExperiment }
}

export const useVariantList = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getVariantList = useCallback(async (entityId: string) => {
    const query = GET_VARIANT_LIST(entityId)
    try {
      setIsLoading(true);

      return await GraphQLRequest<GetVariantListResponseDto>(query)
    } finally {
      setIsLoading(false);
    }
  }, [])

  return{ isLoading, getVariantList }
}

export const useVariant = () => {
  const { variantList, isLoading } = useSelector((store: Store) => store.variants);

  const getVariantByFeatureName = (variantFeature: string): VariantType | Record<string, never> => {
    const featureName = `${variantFeature}-feature`

    return variantList.find(variant => variant.featureName === featureName) || {}
  }

  return {
    isLoading,
    variantList,
    getVariantByFeatureName
  }
}

const SEARCH_PARAM_KEY = 'ab-test-entity-id'

export const useEntityIdQueryParam = () => {
  const { search } = useLocation()
  const querySearchParams = useMemo(() => new URLSearchParams(search), [search])

  return querySearchParams.get(SEARCH_PARAM_KEY)
}
